import React from 'react'
import LiveApi from 'live/lib/api'
import i18n from 'live/services/i18n'
import authorization, { LIVE_PERMISSIONS } from 'live/services/authorization'

import { ptBr } from '../../../i18n/pt_br'
import { enUs } from '../../../i18n/en_us'

import { withSuspenseWrapper } from '../../components/SuspenseWrapper'

const WrapperKPIConfiguration = withSuspenseWrapper(React.lazy(() => import('../Parameters/app')))

const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'pt_br'
const localeFiles = { pt_br: ptBr, en_us: enUs }

export function addi18n(): void {
    i18n.add(localeFiles[locale])
}

const hasPermissionToView =
    authorization.superAdmin ||
    authorization.admin ||
    authorization.Permission.ADMIN ||
    authorization.Permission.OGPERFORMANCE_MANAGE_KPI ||
    authorization.Permission.OGPERFORMANCE_ADMINISTRATE_KPI ||
    authorization.Permission.OGPERFORMANCE_VIEW_KPI

export const KPIPluginConfiguration = {
    async setup() {
        let hasKpiConfiguration = false

        for (const configs of LiveApi.Extension.configuration.entries.orderMap.entries()) {
            hasKpiConfiguration = configs[0]?.area === 'kpi-configurations'
            if (hasKpiConfiguration) {
                break
            }
        }

        if (hasPermissionToView && !hasKpiConfiguration) {
            LiveApi.Extension.configuration.entries.register({
                name: i18n('Rigs and Wells KPI Configuration'),
                area: 'kpi-configurations',
                group: 'Performance',
                component: WrapperKPIConfiguration,
                order: 1.5,
                permissions: [LIVE_PERMISSIONS.MANAGE_HIGH_FREQUENCY_DATA, LIVE_PERMISSIONS.VIEW_HIGH_FREQUENCY_DATA]
            })
        }
    }
}
